import { BundleParams, fetchLanguageLearningBundles } from './apiFetchLanguageLearningBundles';
import { useQuery } from '@tanstack/react-query';
import { browserClient } from '../../../../react-query';
import { GlobalReactQueryOptions } from '../../../../config';

const LANGUAGE_LEARNING_BUNDLES_QUERY_KEY = 'languageLearningBundles';

export const useLanguageLearningBundles = ({ loanFormat, pagination, ageCategory, queryParams }: BundleParams) => {
    const { ...data } = useQuery(
        [LANGUAGE_LEARNING_BUNDLES_QUERY_KEY, { loanFormat, pagination, ageCategory, queryParams }],
        () => {
            return fetchLanguageLearningBundles({
                loanFormat,
                pagination,
                ageCategory,
                queryParams
            });
        },
        { ...GlobalReactQueryOptions }
    );

    const languageLearningData = data;

    return {
        ...data,
        bundles: languageLearningData.data?.hits ?? [],
        totalHits: languageLearningData.data?.totalHits ?? 0
    };
};

export function invalidateLanguageLearningBundles() {
    return browserClient.invalidateQueries({ queryKey: [LANGUAGE_LEARNING_BUNDLES_QUERY_KEY] });
}
